import { combineReducers } from 'redux'
import appErrors from "./data/appErrors"
import bookingFlow from "./data/bookingFlow"
import signin from "./data/signin"
import signup from "./data/signup"
import forgotPassword from "./data/forgotPassword"
import landing from "./data/landing"
import currentUser from "./data/currentUser"
import bookings from "./data/bookings"
import booking from "./data/booking"
import accountProfile from "./data/accountProfile"
import accountSecurity from "./data/accountSecurity"
import residences from "./data/residences"
import affiliateMessages from "./data/affiliateMessages"
import allContracts from "./data/allContracts"
import userAffiliates from "./data/userAffiliates"
import affiliateMessagesForm from "./data/affiliateMessagesForm"
import affiliatePublicData from "./data/affiliatePublicData"

export const dataReducer = combineReducers({
	appErrors,
	bookingFlow,
	signin,
	signup,
	forgotPassword,
	landing,
	currentUser,
	accountProfile,
	accountSecurity,
	bookings,
	booking,
	residences,
	affiliateMessages,
	allContracts,
	userAffiliates,
	affiliateMessagesForm,
	affiliatePublicData,
})


// WEBPACK FOOTER //
// ./src/reducers/data.js